export enum InvoiceStatusType {
    Unpaid = 0,
    PendingPayment = 1,
    PartlyPaid = 2,
    OverPaid = 3,
    FullyPaid = 4,
}